import { transactionWidth } from "../../config/common";
const { Raphael } = require("react-raphael")
const { node } = require ('../../config/clusterlets')


export const convertClusterletIdtoName = (id,clusterlets) => {
    let name = "";
    clusterlets.forEach((clusterlet, index)=> {
        if(clusterlet.id === id){
            name = clusterlet.name;
        }
    })
    return name;
} 

export const generateCommonElements = (array1, array2) => {
  let resultArray = []
  array1.forEach((a1,index) => {
    array2.forEach((a2,index) => {
      if(a1.id === a2.id)
      {
        resultArray.push(a2);
      }
    })
  })
  return resultArray;
}

// to get the highest order from the nested and invoked transaction in a selected transaction
// to find the order of element (nested/ invoked ) to be added
export const createOrder = (transaction) => {

    const newArray = [ ...transaction.invokedTransactions, ...transaction.nestedTransactions, ...transaction.events]

    let highestOrder = {order : 150 }

    if(newArray.length > 0){
      highestOrder = newArray.reduce((acc,current) => {
        return acc.order > current.order ? acc : current
      });
    }
  
    return highestOrder.order + 15
}


//sorting after the order is added from the function addOrderForArray
export const orderTransactions = (transactionArrayWithOrder) => {
    transactionArrayWithOrder.sort((a,b) => a.order - b.order);
    return transactionArrayWithOrder
}


// In transaction array for selected transaction, it has invoked transaction and nested transaction
// the id of those and order

// Since the object corresponding to the nested transacrion/ invoked trans have no order to sort thr arra,
// adding order to the array
export const addOrderForArray = (transaction, transArray) => {
    
  const newArray = [ ...transaction.invokedTransactions, ...transaction.nestedTransactions]

  newArray.forEach(element => {
    transArray.forEach(ta=>{
      if(element.id === ta.id){
        ta.order = element.order
      }
    })
  })

  return transArray;
 }


 /** Create raphael canvas */
 export const createCanvas = (width,height) => {
    let paper = Raphael(document.getElementById("papercanvas"), width, height);
    return paper
 }

 /** Draw clusterlets */
 export const drawClusterlets = (canvas,clusterlets) => {

      let initialX = 50;
      let initialY = 10
      let widthOfRectangle = 150
      let heightOfRectangle = 70
      let rectangleBorderRadius = 0

      let x = initialX
      let y = initialY
      let gap = 100

      let drawnRectangles = []
      let rect;
      let text;
      let textPositionX = 0

      const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
		  const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

      let width = vw || window.innerWidth - (64 + 48)
			let height = vh - 42 || window.innerHeight - (64 + 48 + 30)
      

      clusterlets.forEach( clusterlet => {

          /* Rectangle */
          rect = canvas.rect(x, y, widthOfRectangle, heightOfRectangle, rectangleBorderRadius )
          rect.attr(node)
          drawnRectangles.push({ id: clusterlet.id, drawnObject: rect} )

          /* Name of rectangle */
          textPositionX = x + (widthOfRectangle/2)
          text = canvas.text(textPositionX, (heightOfRectangle/2)+10, clusterlet.id)

          /* Vertical lines for clusterlets */
          canvas.path(['M', x + widthOfRectangle/2 , heightOfRectangle + 10, "V", height] )


          x = x + widthOfRectangle + gap
      })

      return drawnRectangles
 } 

 /** Generate an order for item drawn */
 export const getBorderElement = ( positionY, items ) => {

      if( items.length == 0 ) 
        return false    
      
      items.sort( (a, b) => a.y - b.y )
      let borderItem = items.find( item => item.y >= positionY )      
      return borderItem
     
 }

/** Get previous element by order */
export const getPreviousElement = ( positionY, items ) => {

    items.sort( (a, b) => a.y - b.y )
    let all = items.filter( i => i.y < positionY)

    if( all === undefined || all == null )
      return false 

    if( all.length == 0)
      return false

    return all[ all.length -1 ]

}

/** check if the transaction is used as an invoked transaction 
 * in another transactions
*/
export const transactionsWithSelectedTransAsInvokedTrans = (payload) => {
  // console.log("payload", payload)
  const { selectedTransId, transactions } = payload

  const transactionsWithSelectedTrans = transactions.map(transaction => {
      const invokedTransactionIds = transaction.invokedTransactions?.map(trans => trans.id)
      if(invokedTransactionIds?.includes(selectedTransId)) return transaction.name
  }).filter(i=>i)

  // console.log("transactions with selected trans", transactionsWithSelectedTrans)
  return transactionsWithSelectedTrans

}

export const checkLuaFileDefs = (
  getLuaFilesData,
  getTransactions,
  selectedTransaction,
  allTransactions
) => {

  let luaCodeFiles = []
  getLuaFilesData.map((luaCodeFile, index) => {
    if(luaCodeFile.transaction === selectedTransaction.id){
      luaCodeFiles.push(luaCodeFile);
    }
  } )

  if(luaCodeFiles.length){
    const checkLuaDefinitionsForOnRecvForSelectedTransaction =
		selectedTransaction.events.map((event) => {
        if (event?.draw?.onrecv) {
          if (!getLuaFilesData.length) return false;
          else {
            const dst = event?.draw?.dst;
            const luaFile = getLuaFilesData.find((file) => {
              const splittedFileNameArray = file.fileName.split("/");
              const fileName = splittedFileNameArray.slice(-1);
              if (fileName[0] === `handlers_${dst}.lua`) {
                return file;
              }
            });
            if (luaFile) {
              if (luaFile.data.length) {
                return true;
              } else {
                return false;
              }
            }else{
              return false
            }
          }
        } else {
          return "onrecv_undefined";
        }
      });
  }

  if (selectedTransaction && selectedTransaction.events?.length) {
    const checkLuaDefinitionsForOnRecvForSelectedTransaction =
		selectedTransaction.events.map((event) => {
        if (event?.draw?.onrecv) {
          if (!getLuaFilesData.length) return false;
          else {
            const dst = event?.draw?.dst;
            const luaFile = getLuaFilesData.find((file) => {
              const splittedFileNameArray = file.fileName.split("/");
              const fileName = splittedFileNameArray.slice(-1);
              if (fileName[0] === `handlers_${dst}.lua`) {
                return file;
              }
            });
            if (luaFile) {
              if (luaFile.data.length) {
                return true;
              } else {
                return false;
              }
            }else{
              return false
            }
          }
        } else {
          return "onrecv_undefined";
        }
      });

    const checkLuaDefinitionsForOnSendForSelectedTransaction =
		selectedTransaction.events.map((event) => {
        if (event?.draw?.onsend) {
          if (!getLuaFilesData.length) return false;
          else {
            const src = event?.draw?.src;
            const luaFile = getLuaFilesData.find((file) => {
              const splittedFileNameArray = file.fileName.split("/");
              const fileName = splittedFileNameArray.slice(-1);
              if (fileName[0] === `handlers_${src}.lua`) {
                return file;
              }
            });
            if (luaFile) {
              if (luaFile.data.length > 0) {
                return true;
              } else {
                return false;
              }
            }else{
              return false;
            }
          }
        } else {
          return "onsend_undefined";
        }
      });

    // console.log("check", {
    //   checkLuaDefinitionsForOnRecvForSelectedTransaction,
    //   checkLuaDefinitionsForOnSendForSelectedTransaction,
    // });

    const statusOfLuaFileDef =
      checkLuaDefinitionsForOnRecvForSelectedTransaction
        .concat(checkLuaDefinitionsForOnSendForSelectedTransaction)
        .find((nodes) => nodes === false);

    return statusOfLuaFileDef;
  } else {
    return true;
  }
};

export const generateMessagePositions = (
  board,
  selected,
  { dimensions: { widthOfRectangle, heightofRectangle } = {} }, 
  drawnRectangles,
  events,
  clusterlets,
  arrowPayload
) => {
 
  const arrows = [];
  let yGap = 0;

  for (let index = 0; index < events.length; index++) {

    let event = events[index];
    //console.log(`event-${index}`,events[index])   not used



    // if (!event?.draw?.position || 1==1) {
    //   let startItem;
    //   let endItem;

    //   if (event.draw) {
    //     startItem = board.find((i) => i.name === event.draw.src);
    //     endItem = board.find((i) => i.name === event.draw.dst);
    //   } else {
    //     startItem = board.find((i) => i.name === event.src);
    //     endItem = board.find((i) => i.name === event.dst);
    //   }

    //   // const eStartingPoint = endItem?.startingPoint;
    //   // const sStartinfPoint = startItem?.startingPoint;

    //   const source = drawnRectangles.find( (item ) => item.name === event.draw.src )
    //   const dest = drawnRectangles.find( (item ) => item.name === event.draw.dst)

    //   if(source == undefined || dest == undefined) 
    //     continue;

    //   const sStartinfPoint = source.drawnObj.attr('x') + widthOfRectangle/2;
    //   const eStartingPoint = dest.drawnObj.attr('x') + widthOfRectangle/2;

      
    //   event.draw.endClusterlet = {
    //     name: endItem.name,
    //     startPoint: eStartingPoint,
    //   };
    //   event.draw.startClusterlet = {
    //     name: startItem.name,
    //     startPoint: sStartinfPoint,
    //   };
    //   //const y = heightofRectangle + 40 + index * 60;
    //   const y = event?.draw?.position ? event?.draw?.position.y : (heightofRectangle + 70) * (yGap+1);
    //   yGap++;
    //   event.draw.aPath = `M${sStartinfPoint} ${y}L${eStartingPoint} ${y}`;
    //   event.draw.position = { y: y, x: eStartingPoint };
      
    // }
    
   

    if (!event?.position || 1==1) {
      
      let startItem;
      let endItem;

      let srcNode = event.src;
      let dstNode = event.dst;  
      const source = drawnRectangles.find( (item ) => item.id === event.src )
      const dest = drawnRectangles.find( (item ) => item.id === event.dst)

      if(source == undefined || dest == undefined) 
        continue;

      const sStartinfPoint = source.drawnObj.attr('x') + widthOfRectangle/2;
      const eStartingPoint = dest.drawnObj.attr('x') + widthOfRectangle/2;

      event.dstStartPoint = eStartingPoint;
      event.srcStartPoint = sStartinfPoint;

      //const y = heightofRectangle + 40 + index * 60;
      // const y = event?.position ? event?.position.y : (heightofRectangle + 70) * (yGap+1);
      const y = (heightofRectangle + 70) * (yGap+1);
      yGap++;
      event.draw = { aPath : `M${sStartinfPoint} ${y}L${eStartingPoint-20} ${y}` }

      event.position = { x1: sStartinfPoint, y1: y, x2: eStartingPoint, y2: y } 
      //event.position = { y: y, x: eStartingPoint };   
    }
    
    //arrows.push(event.draw);
    arrows.push(event);
  }
  return arrows;
};

export const generateBoard = (options, /*elements,*/ nodes, width) => {

  const {
    dimensions: { height, offset, widthOfRectangle, heightofRectangle } = {},
  } = options;
  const positions = [];
  const board = [];
  const borderRadius = 10;


  const nodesOrder = nodes !== undefined ? nodes : [];
  let orderedElements = nodes

  
  
  let totalWidth = orderTransactions.length *  transactionWidth;//width//window.screen.width

  let medianIndex = Math.floor( orderedElements.length / 2)
  let nodePositions = {};
  nodePositions[medianIndex] = (totalWidth / 2) - widthOfRectangle;
  let leftX = nodePositions[medianIndex];
  let rightX = nodePositions[medianIndex];


  for(let index = medianIndex - 1 ; index >= 0; index-- ) {
    nodePositions[index] = leftX - ( widthOfRectangle + offset )
    leftX = leftX - (widthOfRectangle + offset );
  }

  for(let index = medianIndex + 1; index < orderedElements.length; index++ ) {
    nodePositions[index] = rightX + widthOfRectangle + offset
    rightX = rightX + widthOfRectangle + offset;
  }

  for (let index = 0; index < orderedElements.length; index++) {
    let x = 10;
    let y = 10;
    let xy = [x, y];

    
    if (index && index >= 1) {
      const [lastX, lastY] = positions[index - 1];
      x = lastX + widthOfRectangle + offset;
      xy = [x, lastY];
    }

    console.log({xy,name:orderedElements[index].name})

    //xy = [ nodePositions[index], y]

    board.push({
      rect: [...xy, widthOfRectangle, heightofRectangle, borderRadius],
      text: [
        x +  widthOfRectangle / 2, //nodePositions[index] + widthOfRectangle / 2,
        heightofRectangle / 2 + 10,
        orderedElements[index].name ? orderedElements[index].name : index,
      ],
      path: [
        "M",
        x+  widthOfRectangle / 2, //nodePositions[index] + widthOfRectangle / 2,
        heightofRectangle + 10, //+ 15, //random 10 + height to cover the node label/move handler
        "V",
        height,
      ],
      name: orderedElements[index].name ? orderedElements[index].name : index,
      startingPoint: x + widthOfRectangle /2, //nodePositions[index] + widthOfRectangle / 2,
      uuid: orderedElements[index].id,
      type: orderedElements[index].type
    });
    positions.push(xy);
  }

  return [board, positions];
};

export const generateEmbemdedTransactionPosition = (
  board,
  positions,
  events,
  selected,
  options,
  nestedTrans,
  transction,
) => {

  const { dimensions: { widthOfRectangle, offset, heightofRectangle } = {} } =
    options;
  //const { embeddedTransactions } = selected;
  let nestedTransForSelected = [];
  let invokedTransactionsForSelected = [];
  let transactionArray = [];
  //let eventsInTranss = [];

  const { nestedTransactions, invokedTransactions } = selected;
  // console.log("events in utios---------------_>",events)

  // selected.events.forEach((event, index) => {
  //   events.forEach((e, index) => {
  //     if(e.id === event.id){
  //       eventsInTranss.push(e)
  //     }
  //   })
  // })

  nestedTransactions.forEach((trans,index) => {
    nestedTrans.forEach((nested,index) => {
      if(nested.id === trans.id){
        nestedTransForSelected.push(nested)
      }
    }) 
  })

  invokedTransactions.forEach((invoked, index) => {
    transction.forEach((transaction,index) => {
      if(transaction.id === invoked.id){
        transaction.isInvoked = true
        invokedTransactionsForSelected.push(transaction)
      }
    }) 
  })

transactionArray = [...nestedTransForSelected, ...invokedTransactionsForSelected]

const orderAdded = addOrderForArray(selected, transactionArray);

const transArray = orderTransactions(orderAdded);


  //if (!embeddedTransactions || !embeddedTransactions.length) return;
  if ((!transArray || !transArray.length) ) return;

  const data = [];
  let previousY = 0
  let  previousHeight= 0

  const allEventYValues = events.map((i) => i.position.y);

  for (let index = 0; index < transArray.length; index++) {
    const {
      //indexs,
      //uuid,
      id,
      clusterlets,
      //attributes = {},
      //expanded,
      //isReused,
    } = transArray[index];

    const attributes = {}

    const eventsInsideTransaction = events.filter(
      (i) => i.isEmbededId === id || i.isWithEmbeddedTransaction === id
    );

    let indexs = [];
    if(transArray[index].isInvoked){
      indexs.push(0,1)
    }
    else{
      clusterlets.forEach((cluster,index)=> {
        indexs.push(index);
      })
    }  

    
    const startIndex = indexs[0];
    const endIndex = indexs[indexs.length - 1];
    let attr = {};

    let xCordinate = positions[startIndex][0] + widthOfRectangle / 2 - 10;
    let yCordinate = heightofRectangle + 50 + offset * index;

    let height = 80;
    let width = positions[endIndex][0] - positions[startIndex][0] + 20;

    if (eventsInsideTransaction && eventsInsideTransaction.length) {
      const yValues = eventsInsideTransaction.map((i) => i.position.y);
      const minY = Math.min(...yValues);
      const maxY = Math.max(...yValues);
      yCordinate = minY - 30;
      height = (maxY - minY > height ? maxY - minY : height) + 30;
    } else if (allEventYValues.length) {

      const eventsOutsideTransactionYValues = events.map((i) => {
          if(!i.isWithEmbeddedTransaction) return i.position.y
      }).filter(value=>value);

      
      const maxY = Math.max(...eventsOutsideTransactionYValues);
      // const maxY = Math.max(...allEventYValues);
      
      maxY>previousY? yCordinate = maxY+30 : yCordinate = previousY+previousHeight+30
    }
    // if (expanded) {
    // if(isReused === true){
    //   data.push({
    //     type: "rect",
    //     x: xCordinate,
    //     y: yCordinate,
  
    //     width: width,
    //     height: height / 2,
    //     stroke: "gray",
    //     fill: "#0a0e8a",
    //     opacity: 1,
    //     "stroke-width": 2,
    //     uuid,
    //     ...(attributes || {}),
    //     expanded: true,
    //   });
    //   previousY = yCordinate
    //   previousHeight = height
    // }
    // else {
    //   data.push({
    //     type: "rect",
    //     x: xCordinate,
    //     y: yCordinate,
  
    //     width: width,
    //     height: height,
    //     stroke: "gray",
    //     fill: "#96B8DC",
    //     opacity: 0.5,
    //     "stroke-width": 2,
    //     id,
    //     ...(attributes || {}),
    //     expanded: true,
    //   });
    //   previousY = yCordinate
    //   previousHeight = height
    // }

    
    if(transArray[index].isInvoked){
      data.push({
        type: "rect",
        x: xCordinate,
        y: yCordinate,    
        width: width,
        height: height/2,
        stroke: "gray",
        fill: "#0a0e8a",
        opacity: 1,
        "stroke-width": 2,
        id,
        ...(attributes || {}),
        expanded: true,
      });
    }
    else{
      data.push({
        type: "rect",
        x: xCordinate,
        y: yCordinate,    
        width: width,
        height: height,
        stroke: "gray",
        fill: "#96B8DC",
        opacity: 0.5,
        "stroke-width": 2,
        id,
        ...(attributes || {}),
        expanded: true,
      });
    }
    previousY = yCordinate
    previousHeight = height

    if(transArray[index].isInvoked) delete transArray[index].isInvoked
    if(transArray[index].order) delete  transArray[index].order
    if(transArray[index].nodes) delete transArray[index].nodes
    // else {
    // 	const halfWidt
    
    // }h = widthOfRectangle / 2;
    // 	const m1 = positions[startIndex][0] + halfWidth;
    // 	const m2 = yCordinate || positions[startIndex][1] + halfWidth;
    // 	const l1 = positions[endIndex][0] + halfWidth;
    // 	const l2 = yCordinate || positions[endIndex][1] + halfWidth;

    // 	data.push({
    // 		uuid,
    // 		path: `M${m1},${m2} L${l1},${l2}`,
    // 		expanded: false,
    // 	});
    // }
  }
  return data;
};
